import React, { Component } from 'react';
import SettingsBlock from 'Components/Common/Settings/SettingsBlock';
import IntegrationSettingsStore from 'Stores/integrationSettingsStore';
import { observer } from 'mobx-react';
import 'Styles/IntegrationSettings.scss';
import LoadView from "Components/Common/loadView";
import { Navigate } from 'react-router-dom';
import AppStore from 'Stores/AppStore';
import TextInputSetting from 'Components/Common/Settings/TextInputSetting';
import TextSetting from 'Components/Common/Settings/TextSetting';

class IntegrationSettings extends Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Настройки интеграции', 'integrationService');

        IntegrationSettingsStore.GetSettings();
    }

    GetStatusClass(hasError) {
        return hasError ? 'text-setting-bad' : 'text-setting-good';
    }

    render() {
        if (this.props.migrationInProcess) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }

        return (
            <div className='integration-settings'>
                <div className='integration-settings-settings-container'>
                    <SettingsBlock
                        key='integration-settings-block'
                        title='Веб-служба'>

                        <TextInputSetting
                            id='integration-service-path'
                            key='integration-service-path'
                            title='URL:'
                            value={IntegrationSettingsStore.dmsis.servicePath}
                            onChanged={(value) => IntegrationSettingsStore.SetDmsisServicePath(value)} />

                        <TextSetting
                            id='dmsis-status'
                            key='dmsis-status'
                            title='Статус:'
                            className={this.GetStatusClass(IntegrationSettingsStore.dmsis.hasError)}
                            value={IntegrationSettingsStore.dmsis.status} />

                        <TextSetting
                            id='dmsis-time'
                            key='dmsis-time'
                            title='Время DMSIS:'
                            value={IntegrationSettingsStore.dmsis.dmsisTime} />

                        <TextSetting
                            id='smr-time'
                            key='smr-time'
                            title='Время СМР:'
                            value={IntegrationSettingsStore.dmsis.localTime} />

                        <TextSetting
                            id='dmsis-version'
                            key='dmsis-version'
                            title='Версия DMSIS:'
                            value={IntegrationSettingsStore.dmsis.dmsisVersion} />

                    </SettingsBlock>
                    {
                        AppStore.productModeSettings?.cbMode ?
                            <SettingsBlock
                                key='karma-settings-block'
                                title='КАРМА'>

                                <TextInputSetting
                                    id='karma-service-path'
                                    key='karma-service-path'
                                    title='Строка инициализации:'
                                    value={IntegrationSettingsStore.carma.servicePath}
                                    onChanged={(value) => IntegrationSettingsStore.carma.servicePath = value} />

                                <TextSetting
                                    id='karma-status'
                                    key='karma-status'
                                    title='Статус:'
                                    className={this.GetStatusClass(IntegrationSettingsStore.carma.hasError)}
                                    value={IntegrationSettingsStore.carma.status} />

                            </SettingsBlock>
                            : ''
                    }
                </div>
                <div className='settings-buttons-container'>
                    <button className="blue-button"
                        onClick={_ => IntegrationSettingsStore.SaveSettings()}>Сохранить</button>
                </div>
                {IntegrationSettingsStore.settingsLoading ? <LoadView modal={true} /> : ''}
            </div>
        )
    }
}

export default observer(IntegrationSettings);